<template>
    <div>
        <el-dialog
            :title="dialogFormTitle"
            :visible.sync="dialogFormVisible"
            :append-to-body="true"
            width="30%"
            :center="true"
            top="20vh"
            :close-on-click-modal="false"
            :before-close="() => closeOverTimeDelDialog()"
            v-loading.fullscreen.lock="login_loading"
        >
            <div>
                <el-form
                    :model="OverTimeDel"
                    :rules="rules"
                    ref="OverTimeDelEditForm"
                    label-width="100px"
                    size="small"
                >
                    <div v-if="show_type">
                        <el-form-item  label="员工" prop="staff_id">
                            <el-select
                                v-model="OverTimeDel.staff_id"
                                filterable
                                clearable
                                placeholder="选择员工"
                                class="staff_idc"
                            >
                                <el-option
                                    v-for="item in AllStaff"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="作废小时" prop="duration">
                            <el-input-number
                                v-model="OverTimeDel.duration"
                                :min="0"
                                :step="0.5"
                                :precision="1"
                                :step-strictly="true"
                                size="small"
                                class="input_number"
                            ></el-input-number>
                        </el-form-item> 
                    </div>
                    <div v-else>
                        <el-descriptions
                            class="margin-top"
                            :column="1"
                            :labelStyle="{'width':'120px','text-align':'center'}"
                            :contentStyle="{'text-align': 'center'}"
                            border
                        >
                            <el-descriptions-item>
                                <template slot="label">
                                    <span>员工</span>
                                </template>
                                <span>{{OverTimeDel.staff_name}}</span>
                            </el-descriptions-item>
                            <el-descriptions-item>
                                <template slot="label">
                                    <span>作废小时</span>
                                </template>
                                <span>{{OverTimeDel.duration}}</span>
                            </el-descriptions-item>
                            <el-descriptions-item>
                                <template slot="label">
                                    <span>创建人</span>
                                </template>
                                <span>{{OverTimeDel.create_staff_name}}</span>
                            </el-descriptions-item>
                            <el-descriptions-item>
                                <template slot="label">
                                    <span>创建时间</span>
                                </template>
                                <span>{{OverTimeDel.create_time}}</span>
                            </el-descriptions-item>
                        </el-descriptions>
                    </div>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <div v-if="show_type===0">
                    <el-button
                        v-if="$_has(edit_auth)"
                        type="primary"
                        plain
                        @click="$emit('show_edit')"
                        >修改</el-button
                    >
                    <el-button
                        v-if="$_has(del_auth)"
                        type="danger"
                        plain
                        @click="OverTimeDelDel('OverTimeDelEditForm')"
                        >删除</el-button
                    >
                    <el-button
                        plain
                        @click="closeOverTimeDelDialog()"
                        >关闭</el-button
                    >
                </div>
                <div v-else-if="show_type===1">
                    <el-button
                        type="success"
                        plain
                        @click="submitInsert('OverTimeDelEditForm')"
                        >确定</el-button
                    >
                    <el-button
                        type="warning"
                        plain
                        @click="resetForm()"
                        >重置</el-button
                    >
                    <el-button
                        plain
                        @click="closeOverTimeDelDialog()"
                        >关闭</el-button
                    >
                </div>
                <div v-else>
                    <el-button
                        type="success"
                        plain
                        @click="submitEdit('OverTimeDelEditForm')"
                        >确定修改</el-button
                    >
                    <el-button
                        plain
                        @click="closeOverTimeDelDialog()"
                        >取消操作</el-button
                    >
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { over_time_del_add_request,over_time_del_del_request,over_time_del_edit_request } from '@/network/hrm/OverTimeDel.js'

export default {
    name: 'OverTimeDelEditComponent',
    data() {
        return {
            login_loading: false,
            OverTimeDel: {
                staff_id: '',
                duration: ''
            },
            rules: {
                staff_id: [
                    {
                        required: true,
                        message: '缺少员工',
                        trigger: 'blur',
                    }
                ],
                duration: [
                    {
                        required: true,
                        message: '缺少作废时长',
                        trigger: 'blur',
                    }
                ]
            }
        }
    },
    computed: {
        dialogFormTitle() {
            if(this.show_type === 0) {
                return '加班作废详情'
            } else if (this.show_type === 1) {
                return '添加加班作废'
            } else {
                return '修改加班作废'
            }
        }
    },
    methods: {
        closeOverTimeDelDialog() {
            this.resetForm()
            this.$emit('exitOverTimeDelDialog')
        },
        submitInsert(formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    return
                }
                this.OverTimeDelInsert(formName)
            })
        },
        OverTimeDelInsert(formName) {
            this.login_loading = true
            over_time_del_add_request(this.OverTimeDel)
                .then((s) => {
                    this.login_loading = false
                    if (s.status === 0) {
                        this.$message.success('添加成功!')
                        this.$emit('exitOverTimeDelDialog')
                        this.$emit('search')
                        this.$emit('details_row',s.result.id*1)
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.login_loading = false
                    this.$message.error(err)
                })
        },
        resetForm() {
            this.OverTimeDel = {
                staff_id: '',
                duration: ''
            }
        },
        submitEdit(formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    return
                }
                this.OverTimeDelEdit(formName)
            })
        },
        OverTimeDelEdit(formName) {
            this.login_loading = true
            this.OverTimeDel.id = this.id
            over_time_del_edit_request(this.OverTimeDel)
                .then((s) => {
                    this.login_loading = false
                    if (s.status === 0) {
                        this.$message.success('修改成功!')
                        this.$emit('exitOverTimeDelDialog')
                        this.$emit('search')
                        this.$emit('details_row',this.OverTimeDel.id)
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.login_loading = false
                    this.$message.error(err)
                })
        },
        OverTimeDelDel(formName) {
            this.$confirm(
                '是否确定删除？（一经删除，将无法再进行恢复，请谨慎操作！）',
                '温馨提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                }
            )
                .then(() => {
                    over_time_del_del_request(this.id)
                        .then((s) => {
                            if (s.status === 0) {
                                this.$message.success('删除成功!')
                                this.$emit('search')
                            } else {
                                this.$message.error(s.msg)
                            }
                        })
                        .catch((err) => {
                            this.$message.error(err)
                        })
                        .finally(() => this.closeOverTimeDelDialog())
                })
                .catch((err) => {})
        },
    },
    filters: {},
    props: {
        dialogFormVisible: Boolean,
        id: {
            type: Number,
            default() {
                return 0
            },
        },
        AllStaff: {
            type: Array,
            default() {
                return []
            },
        },
        over_time_del_details_data: {
            type: Object,
            default() {
                return {}
            },
        },
        show_type: {
            type:Number,
            default() {
                return 0
            },
        },
        edit_auth: String,
        del_auth: String
    },
    created() {},
    destoryed() {},
    mounted() {},
    updated() {},
    components: {},
    watch: {
        over_time_del_details_data(newVal) {
            this.OverTimeDel = newVal
        },
    },
}
</script>

<style lang='less'>
.staff_idc,.input_number {
    width: 100%;
}
</style>